import { type ComponentProps } from "react";

const ProfileIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="currentColor"
      {...props}
    >
      <path
        d="M4.59545 20.1239L3.78356 20.758L4.44156 21.5507C6.96749 24.5936 10.5079 25.8 13.5 25.8C16.4921 25.8 20.0325 24.5936 22.5584 21.5507L23.2164 20.758L22.4046 20.1239C19.9561 18.2115 16.8661 17.05 13.5 17.05C10.1339 17.05 7.0439 18.2115 4.59545 20.1239ZM1 14C1 7.10029 6.60029 1.5 13.5 1.5C20.3997 1.5 26 7.10029 26 14C26 20.8997 20.3997 26.5 13.5 26.5C6.60029 26.5 1 20.8997 1 14ZM19.225 10.625C19.225 7.46722 16.6578 4.9 13.5 4.9C10.3422 4.9 7.775 7.46722 7.775 10.625C7.775 13.7828 10.3422 16.35 13.5 16.35C16.6578 16.35 19.225 13.7828 19.225 10.625Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

ProfileIcon.displayName = "ProfileIcon";

export default ProfileIcon;
